import React, { useState } from "react";
import { Container, Modal } from "react-bootstrap";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const videoBaseURL = `${process.env.REACT_APP_BUCKET}/videos/`;

const MachineLearning = () => {
  const [show, setShow] = useState(false);
  const [videoActivo, setVideoActivo] = useState(null);

  const handleShow = (video) => {
    setVideoActivo(video);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setVideoActivo(null);
  };

  // Estructura simplificada de los 4 videos
  const videos = [
    {
      nombre: "Video 1: ¿Por qué un ingeniero debe aprender ML?",
      url: `${videoBaseURL}ML1.mp4`,
      conceptoclave: [
        'El ML como un "filtro" que aprende de ejemplos (datos) en lugar de ecuaciones (reglas programadas).',
      ],
      termino: [
        'Filtro digital tradicional vs. Filtro basado en ML.'
      ]
    },
    {
      nombre: "Video 2: Aprendizaje Supervisado vs. No Supervisado",
      url: `${videoBaseURL}ML2.mp4`,
      conceptoclave: [
        'La diferencia fundamental entre aprender con un "manual de respuestas" (etiquetas) y aprender sin él.',
      ],
      termino: [
        'Datos etiquetados (Supervisado) vs. Datos crudos (No Supervisado).'
      ]
    },
    {
      nombre: "Video 3: El Poder del ML Supervisado (Regresión y Clasificación)",
      url: `${videoBaseURL}ML3.mp4`,
      conceptoclave: [
        'Las dos tareas principales cuando sí tienes etiquetas.',
      ],
      termino: [
        'Regresión (predecir un número, ej. "latencia en ms") y Clasificación (predecir una categoría, ej. "tráfico de voz").'
      ]
    },
    {
      nombre: "Video 4: El Poder del ML No Supervisado (Clustering y Detección de Anomalías)",
      url: `${videoBaseURL}ML4.mp4`,
      conceptoclave: [
        'Las dos tareas principales cuando no tienes etiquetas.',
      ],
      termino: [
        'Clustering (encontrar grupos naturales, ej. "segmentar antenas") y Detección de Anomalías (encontrar al "bicho raro", ej. "alerta de AIOps").'
      ]
    },
    {
      nombre: "Video 5: Deep Learning (Cuando el ML Clásico no es Suficiente)",
      url: `${videoBaseURL}ML5.mp4`,
      conceptoclave: [
        'Cuándo usar Redes Neuronales (Deep Learning) vs. ML Clásico.',
      ],
      termino: [
        'Datos Estructurados (tablas, ML clásico) vs. Datos No Estructurados (señales de RF, imágenes, audio).'
      ]
    },
    {
      nombre: "Video 6: El Proceso de ML de un Ingeniero",
      url: `${videoBaseURL}ML6.mp4`,
      conceptoclave: [
        'El flujo de trabajo de 5 pasos para construir un modelo en el mundo real.',
      ],
      termino: [
        'Adquisición, Limpieza, Ingeniería de Características (Features), Entrenamiento/Prueba e Implementación.'
      ]
    },
  ];

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Machine Learning</h1>
        </div>

        <div className="orgproc-grid-3col">
          {videos.map((video, idx) => (
            <div className="orgproc-card" key={video.nombre}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Video #{idx + 1}</div>
                <div className="orgproc-card-title">{video.nombre}</div>

                <div className="orgproc-card-block">
                  <div className="orgproc-card-block-label">Concepto Clave</div>
                  <ul className="orgproc-card-list">
                    {video.conceptoclave.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="orgproc-card-block">
                  <div className="orgproc-card-block-label">Analogía / Términos</div>
                  <ul className="orgproc-card-list">
                    {video.termino.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="orgproc-card-actions">
                  <button
                    type="button"
                    className="orgproc-card-btn"
                    onClick={() => handleShow(video)}
                  >
                    Reproducir Video →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>

      {/* Modal para reproducir video */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="video-modal-dialog"
        contentClassName="video-modal-content"
      >
        <Modal.Header closeButton closeVariant="white" className="video-modal-header">
          <Modal.Title className="video-modal-title">{videoActivo?.nombre}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="video-modal-body">
          <div className="video-modal-player">
            {videoActivo && (
              <video key={videoActivo.url} controls autoPlay>
                <source src={videoActivo.url} type="video/mp4" />
                Tu navegador no soporta la reproducción de video.
              </video>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default MachineLearning;
